import { SectionHandler, SectionHandlerGroup } from '../entity.handler';
import { AdminEditorService } from '../../admin.service';
import { EventEmitter } from '@angular/core';

export interface FeedSectionValues {
    id: string;
    feedType: string;
}

export class FeedSectionHandler implements SectionHandler<{ id: string }, FeedSectionValues> {

    type = 'feed';
    icon = '';
    bulk: false;
    description = '';
    title: '';
    settings: any = {};

    onSettingsChanged = new EventEmitter<any>();

    constructor(
        public admin: AdminEditorService,
        public feedType: string,
    ) {
    }

    async applyUpdate(_entity: any, _payload: any): Promise<any> {
        throw new Error('applyUpdate not supported');
    }

    async mapEntityToEditor(entity: { id: string }): Promise<FeedSectionValues> {
        return {
            id: entity.id,
            feedType: this.feedType
        };
    }

    async mapEditorToEntity(_entity: any, _values: FeedSectionValues): Promise<any> {
        throw new Error('mapEditorToEntity not supported');
    }

    updateSettings(settings: any) {
        this.settings = {
            ...this.settings,
            ...settings
        };
        this.onSettingsChanged.emit(this.settings);
    }

}

export class LogsSectionHandler extends FeedSectionHandler {

    constructor(
        admin: AdminEditorService,
        entityType: string
    ) {
        super(admin, 'logs');
        this.settings = {
            entityType
        }
    }


}

export function buildLogsSectionGroup(admin: AdminEditorService, entityType: string): SectionHandlerGroup<any> {

    let levels = ['info', 'debug', 'warn', 'error'];
    const section = new LogsSectionHandler(admin, entityType);

    return {
        name: admin.i18n.instant('ADMIN.EDITOR.LOGS'),
        actions: [{
            id: 'refresh',
            icon: 'redo',
            click: () => {
                section.updateSettings({});
            },
        }, {
            id: 'filter',
            icon: 'filter',
            menu: levels.map(level => ({
                id: level,
                type: 'toggle',
                checked: levels.includes(level),
                closeDropdownOnClicked: false,
                text: admin.i18n.instant('ADMIN.EDITORS.SHARED.LOGS.LEVELS.' + level.toUpperCase()),
                action: () => {
                    if (levels.includes(level)) {
                        levels = levels.filter(x => x !== level);
                    } else {
                        levels.push(level);
                    }
                    section.updateSettings({ levels: levels.join(',') });
                },
            })),
        }],
        sections: [section],
    };
}
